const ManualSolicitationImage = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="154"
			height="137"
			viewBox="0 0 154 137"
			fill="none"
		>
			<g clipPath="url(#clip0_6207_18614)">
				<path
					d="M123.903 52.6885H11.8574C10.3572 52.6885 9.14844 53.9058 9.14844 55.3974V121.964C9.14844 123.465 10.3658 124.682 11.8574 124.682H123.911C125.411 124.682 126.629 123.465 126.629 121.964V55.406C126.629 53.9058 125.411 52.6971 123.911 52.6971L123.903 52.6885Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M132.835 124.15H4.49273C2.94107 124.15 1.68945 126.045 1.68945 128.385V130.331C1.68945 132.672 2.94107 134.566 4.49273 134.566H132.835C134.386 134.566 135.638 132.672 135.638 130.331V128.385C135.638 126.045 134.386 124.15 132.835 124.15Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M13.3398 125.762H123.122"
					stroke="#AFC1DB"
					strokeWidth="6.69"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M105.384 29.2334H32.6703C27.912 29.2334 24.0547 33.0907 24.0547 37.849V106.371C24.0547 111.129 27.912 114.986 32.6703 114.986H105.384C110.142 114.986 113.999 111.129 113.999 106.371V37.849C113.999 33.0907 110.142 29.2334 105.384 29.2334Z"
					fill="#EAF1FC"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M106.542 99.2973C114.027 99.2973 120.095 93.2292 120.095 85.7439C120.095 78.2585 114.027 72.1904 106.542 72.1904C99.0564 72.1904 92.9883 78.2585 92.9883 85.7439C92.9883 93.2292 99.0564 99.2973 106.542 99.2973Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="4.1"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M99.4102 84.4581L102.556 91.3849L113.521 82.7607"
					stroke="#AFC1DB"
					strokeWidth="3.88"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M42.3156 90.9477C44.6829 90.9477 46.602 89.0286 46.602 86.6614C46.602 84.2941 44.6829 82.375 42.3156 82.375C39.9484 82.375 38.0293 84.2941 38.0293 86.6614C38.0293 89.0286 39.9484 90.9477 42.3156 90.9477Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M68.3332 90.9477C70.7005 90.9477 72.6196 89.0286 72.6196 86.6614C72.6196 84.2941 70.7005 82.375 68.3332 82.375C65.9659 82.375 64.0469 84.2941 64.0469 86.6614C64.0469 89.0286 65.9659 90.9477 68.3332 90.9477Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M46.9609 86.6611H63.1376"
					stroke="#AFC1DB"
					strokeWidth="3.09"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M73.5449 86.6611H92.662"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M38.7656 45.0752H92.345"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M38.7656 55.0801H92.345"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M38.7656 65.4102H72.7735"
					stroke="#AFC1DB"
					strokeWidth="3.94"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M146.19 39.3492L152.011 42.5297L146.19 45.7187L143.01 51.5396L139.821 45.7187L134 42.5297L139.821 39.3492L143.01 33.5283L146.19 39.3492Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M131.599 12.6795L141.552 18.1231L131.599 23.5668L126.155 33.5283L120.703 23.5668L110.75 18.1231L120.703 12.6795L126.155 2.72656L131.599 12.6795Z"
					fill="white"
					stroke="#AFC1DB"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_6207_18614">
					<rect
						width="154"
						height="135.526"
						fill="white"
						transform="translate(0 0.737305)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default ManualSolicitationImage;
